import { useEffect } from 'react';
import { useCEProductSelector } from '../../bitf-customization-engine/useCEProductSelector';

export default function CEProductCollectionSelector({ productSelectorHook, localization }) {
  const { collections, selectedCollection, setCollection, initProductSelector } =
    productSelectorHook || useCEProductSelector({ localization });

  // Initialize data on mount
  useEffect(() => {
    if (!collections || collections.length === 0) {
      initProductSelector({ localization });
    }
  }, [initProductSelector, collections, localization]);

  return (
    <div className="product-customization__collection-container">
      <div className="product-customization__collection-buttons">
        {collections.map(
          (collection) =>
            collection?.id && (
              <button
                key={collection.id}
                className={`collection-image-button ${selectedCollection?.id === collection.id ? 'selected' : ''}`}
                onClick={() => setCollection(collection)}
              >
                {collection.image?.url && (
                  <img
                    src={collection.image.url}
                    alt={collection.image.altText || collection.title}
                    className="collection-image"
                  />
                )}
                <div
                  className={`collection-title ASRomaFont Small ${selectedCollection?.id === collection.id ? 'Medium' : ''}`}
                >
                  {collection.title}
                </div>
              </button>
            ),
        )}
      </div>
    </div>
  );
}
